import type { UpdateTaxCodePayload, UpdateTaxCodeResponse } from './types';

import { ENDPOINT } from '~/constants/endpoints';

import type { UUID } from '~/types/common';

import { vestigasApi } from '~/services/kyClient';

import {
  zodUpdateTaxCodePayloadSchema,
  zodUpdateTaxCodeResponseSchema,
} from './validations';

/**
 * Updates all editable fields of one tax code.
 *
 * @param taxCodeId - The tax code id.
 * @param payload - The editable tax-code fields.
 * @returns The updated tax code.
 * @see https://app.dev.vestigas.com/redoc#tag/Tax-Codes
 */
export const updateTaxCode = async (
  taxCodeId: UUID,
  payload: UpdateTaxCodePayload,
) =>
  vestigasApi
    .put(ENDPOINT.TAX_CODE.UPDATE(taxCodeId), {
      json: payload,
      validate: {
        body: zodUpdateTaxCodePayloadSchema,
        response: zodUpdateTaxCodeResponseSchema,
      },
    })
    .json<UpdateTaxCodeResponse>();
